import { ApiKey, ApiPathManager } from "app/shared/services/api-path";
import { getDataHeaders, getUserHeader } from "app/shared/services/header-builder";
import { REQUESTINPUT } from "app/shared/services/services-model.type";
import { instance } from "app/shared/util/token-store";

export const fetchLoyaltyAccountService = async () => {
  const { action, massageID, url } = ApiPathManager(ApiKey.GET_ACCOUNT_LOYALTY);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};

export const fetchLoyaltyWebviewService = async () => {
  const { url } = ApiPathManager(ApiKey.GET_LOYALTY_WEBVIEW);
  const response: any = await instance.get(url + "/");
  return response;
};
